import React from 'react';
import {mergeStyles} from 'components/FluentUICompat';
import {
	ParagraphsList,
	ParagraphsListProps,
} from './components/DocumentDetails';
import {SidePaneForParagraphs} from './SidePaneForParagraphs';

export default function ParagraphsComparisonPanel(props: ParagraphsListProps) {
	const getClassName = (): string => {
		return mergeStyles({
			width: '50%',
		});
	};

	return (
		<SidePaneForParagraphs extraStyle={getClassName()}>
			<ParagraphsList
				filterable={false}
				onShouldVirtualize={() => false}
				sticky
				{...props}
			/>
		</SidePaneForParagraphs>
	);
}
